import { SVGProps } from 'react'

export const History = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.47239 8H6.75H7.5V9.5H6.75H2.75H2V8.75V4.75V4H3.5V4.75V6.68978C5.27084 3.87323 8.40919 2 11.9864 2C17.5158 2 22 6.47612 22 12C22 17.5238 17.5158 22 11.9864 22C7.62599 22 3.91756 19.2169 2.54298 15.3336L2.29273 14.6265L3.70676 14.126L3.95702 14.833C5.12582 18.1351 8.28007 20.5 11.9864 20.5C16.6894 20.5 20.5 16.6934 20.5 12C20.5 7.30662 16.6894 3.5 11.9864 3.5C8.73357 3.5 5.90591 5.32143 4.47239 8ZM12.75 7V7.75V11.6893L16.0303 14.9697L16.5607 15.5L15.5 16.5607L14.9697 16.0303L11.4697 12.5303L11.25 12.3107V12V7.75V7H12.75Z"
      fill="currentColor"
    />
  </svg>
)

